import { createFileRoute } from '@tanstack/react-router';
import { validateSetPasswordSearch } from '@citylytics/web-session/session/utils';
import { SetPasswordPage } from '~/modules/users/users.components/set-password-page';

// The path Supertokens uses for its links; a municipality user's invite points here.
export const Route = createFileRoute('/auth/reset-password')({
  validateSearch: validateSetPasswordSearch,
  staticData: { pageContract: { exempt: 'a signed-out form over the video backdrop' } },
  component: SetPasswordPage,
});
